import i18n from '@/i18n'
import moment from 'moment'

export default {
  data: function () {
    return {
      OUTSTANDING_PROJECTS: this.$t('explore.outstandingProjects'),
      OUTSTANDING: 'Outstanding',
      REGIONAL_AWARDS: 'Regional Awards',
      REGIONAL: 'Regional',
      CHALLENGE_AWARDS: 'Challenge Awards',
      CHALLENGE: 'Challenge',
      YSC_AWARDS: 'YSC Awards',
      YSC: 'YSC',
      STEM_EXPO: 'STEM Expo',
      STEM_EXPO_HASHTAG: 'STEMExpo',
      LASSONDE_HASHTAG: 'BESTLassonde',
      LASSONDE_BOOTCAMP: 'STEM Entrepreneurship Bootcamp | BEST-Lassonde'
    }
  },
  computed: {
    outstandingProjectPendingMessage: function () {
      return i18n.t('explore.outstandingProjectPendingMessage')
    },
    stemExpoPendingMessage: function () {
      return i18n.t('explore.stemExpoPendingMessage')
    },
    yscCategoryError: function () {
      if (this.$route.query.tag === this.STEM_EXPO_HASHTAG || this.$route.query.tag === this.LASSONDE_HASHTAG) {
        return this.stemExpoPendingMessage
      } else {
        const jsonStr = `viewAll.${this.$route.query.category}`
        return i18n.t(jsonStr)
      }
    }
  },
  methods: {
    challengePendingMessage: function (title) {
      const str = i18n.t('explore.challengePendingMessage')
      return str.replace('CATEGORY_NAME', title)
    },
    yscErrorMessages: function (title) {
      if (title === this.$t('outstandingProjects')) {
        return this.outstandingProjectPendingMessage
      } else if (title === 'STEM Expo') {
        return this.stemExpoPendingMessage
      } else if (title === 'Lassonde Bootcamp') {
        return this.stemExpoPendingMessage
      } else {
        return this.challengePendingMessage(title)
      }
    },
    duringDisableEditPeriod: function (projectTags, created) {
      // Timezone example:
      // PDT 2020-05-18T23:59:59Z
      // EDT 2020-05-19T02:59:59Z
      // UTC 2020-05-19T06:59:59Z == EDT + 4h == PDT + 7h
      let isYSCProject = false
      if (projectTags) {
        isYSCProject = projectTags.find(tag => tag.name === 'YSC')
      }

      if (!isYSCProject) {
        return false
      }
      const disablePeriodStart = '2020-05-20T06:59:59Z' // PDT May 19 11:59:59PM
      const disablePeriodEnd = '2020-05-30T06:59:59Z' // PDT May 29 11:59:59PM
      const date = moment.utc().format()

      const duringDisablePeriod = moment(date).isAfter(disablePeriodStart) && moment(date).isBefore(disablePeriodEnd)
      const isCreatedBeforeDeadline = moment(created).isBefore(disablePeriodStart)
      return isCreatedBeforeDeadline && duringDisablePeriod
    }
  }
}
